// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-menu{background:url(/loverly-logo-cut.svg);background-position-y:100%;background-repeat:no-repeat;background-size:100%}.footer-menu .topic-section{margin-bottom:1.25rem}@media (min-width:768px){.footer-menu .nav-3 .topic-section{margin-bottom:1.25rem}}.footer-menu .nav-4 .title{display:none}@media (min-width:768px){.footer-menu .nav-4 .title{display:block;visibility:hidden}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
